<template>
  <div v-loading.fullscreen="loading">
    <div v-if="!loading">
      <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'userList' }">Users</el-breadcrumb-item>
        <el-breadcrumb-item v-if="model">{{ model.email }}</el-breadcrumb-item>
      </el-breadcrumb>

      <h2 class="page-title">User</h2>

      <app-user-detail v-if="tab === '0'" :user="model"></app-user-detail>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app-user-show",

  props: {
    id: String
  },

  data() {
    return {
      tab: "0"
    };
  },

  computed: {
    ...mapGetters({
      loading: "user/loading",
      model: "user/model"
    })
  },

  created() {
    this.$store
      .dispatch("user/detail", this.id)
      .catch(() => this.$router.push({ name: "userList" }));
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/clear");
    next();
  }
};
</script>
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/user/user-show.vue?2bd0fc1c